import { Injectable } from '@angular/core';
import { Http, Weaver, Wrapper } from '@skylab-angular-shared/core';
import { FiscalDeviceRepositoryBase } from '@skylab-shared/business';
export { FiscalDeviceRepositoryBase };

@Injectable({ providedIn: 'root'})
@Wrapper(FiscalDeviceRepositoryBase)
export class FiscalDeviceRepository {
    public constructor(
        weaver: Weaver,
        http: Http
    ) { }
}
